<div class="coupon-card coupon-card-first" *ngIf="data">
    <div class="card-content">
      <table class="table coupon-table" *ngIf="!events.races.includes(eventId) || (eventId == 'in_play')">
        <thead>
          <tr>
            <th style="width: 63%;">Game</th>
            <th colspan="2">1</th>
            <th colspan="2">X</th>
            <th colspan="2">2</th>
          </tr>
        </thead>
        <tbody *ngFor="let dt of data;trackBy:trackByIndex;">
          <tr *ngIf="viewBy == 'c'">
            <td class="p-0" colspan="7">
              <div class="competition-head">
                <h3>{{dt?.name}}</h3>
              </div>
            </td>
          </tr>
          <tr *ngFor="let item of dt?.data;trackBy:trackByIndex;">
            <td>
              <div class="game-name">
                <span class="sport-icon" *ngIf="eventId == 'in_play'"><img src="https://speedcdn.io/assets/diamond-client-v8/{{item?.event_type_id}}.png" alt=""></span>
                <a href="javascript:void(0)" [routerLink]="['/game-detail', item.event_id]" class="text-dark">{{(item.name) ? item.name : item.market_name}} / {{(item.open_date_format) ? (item.open_date_format | date : 'MMM dd YYYY HH:mm') : item.market_start_time_format | date : 'MMM dd YYYY HH:mm'}} (IST)</a>
                <em class="binary-event-em" *ngIf="events.binary.includes(item?.event_type_id)"> <i class="fa fa-hand-point-left"></i> Click here</em>
                <em class="abo-em" *ngIf="item.featured_event == 2 && item.in_play == 0">Bet open</em>
              </div>
              <div class="game-icons">
                <!-- <span class="game-icon"><span *ngIf="item.featured_event == 2" class="openbet" >Bet-Open</span></span>  -->
                <span class="game-icon"><span *ngIf="item.in_play == 1" class="active" ></span></span> 
                <span class="game-icon"><i *ngIf="item.tv_channel != '' && item.tv_channel != null" class="fas fa-tv v-m icon-tv"></i></span> 
                <span class="game-icon"><img *ngIf="item.fancy_active == 1" src="https://speedcdn.io/assets/diamond-client-v8/ic_fancy.png" class="fancy-icon"></span> 
                <span class="game-icon"><img *ngIf="item.bm_active == 1" src="https://speedcdn.io/assets/diamond-client-v8/ic_bm.png" class="bookmaker-icon"></span> 
                <span class="game-icon">
                  <img *ngIf="item.category == events_category?.virtual" src="https://speedcdn.io/assets/diamond-client-v8/sports_esports.png" class="cardgame-icon">
                  <img *ngIf="item.category == events_category?.cards" src="https://speedcdn.io/assets/diamond-client-v8/card-game.png" class="cardgame-icon">
                </span> 
                <span class="game-icon">
                  <span *ngIf="item.custom_active != ''">{{item.custom_active}}</span>
                  <!-- <img src="assets/img/game-icon.svg" class="ic-card"> -->
                  <!-- <img src="assets/img/ic_vir.png" class="ic-card"> -->
                </span>
              </div>
              
            </td>
            <td>
              <button class="{{odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.key}} back">
                  <span class="odd">{{!(odds[item?.market_id] &&odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.price) ? odds[item?.market_id]?.runners[0]?.ex?.availableToBack[0]?.price : '-' }} </span>
              </button>
          </td>
          <td>
              <button class="{{odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.key}} lay">
                  <span class="odd">{{!(odds[item?.market_id] &&odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.price) ? odds[item?.market_id]?.runners[0]?.ex?.availableToLay[0]?.price : '-' }}</span>
              </button>
          </td>
          <td>
              <button class="{{odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.key}} back">
                  <span class="odd">{{!(odds[item?.market_id] &&odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.price) ? odds[item?.market_id]?.runners[2]?.ex?.availableToBack[0]?.price : '-' }}</span>
              </button>
          </td>
          <td>
              <button class="{{odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.key}} lay">
                  <span class="odd">{{!(odds[item?.market_id] &&odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.price) ? odds[item?.market_id]?.runners[2]?.ex?.availableToLay[0]?.price : '-' }}</span>
              </button>
          </td>
          <td>
              <button class="{{odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.key}} back">
                  <span class="odd">{{!(odds[item?.market_id] &&odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.price) ? odds[item?.market_id]?.runners[1]?.ex?.availableToBack[0]?.price : '-' }}</span>
              </button>
          </td>
          <td>
              <button class="{{odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.key}} lay">
                  <span class="odd">{{!(odds[item?.market_id] &&odds[item?.market_id]?.numberOfRunners <= 3) ? '-' : (odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.price) ? odds[item?.market_id]?.runners[1]?.ex?.availableToLay[0]?.price : '-' }}</span>
              </button>
          </td>
          </tr>
         
        </tbody>
      </table>

      <tabset *ngIf="events.races.includes(eventId)" class="">
        <tab [heading]="item?.event_country_code" *ngFor="let item of data;trackBy:trackByIndex;">
          <div class="bet-table position-relative horse-table" >
            <div class="bet-table-body">
                <div class="bet-table-row" *ngFor="let rc of item?.data;trackBy:trackByIndex;">
                    <div class="bet-nation-name">
                        <div class="game-icon"><i class="fas fa-tv icon-tv"></i></div>
                        <div class="bet-nation-game-name"><span>{{rc?.event_name}}</span></div>
                    </div>
                    <div class="horse-time-detail" >
                        <a *ngFor="let race of rc?.data;trackBy:trackByIndex;" href="javascript:void(0);" [routerLink]="['/game-detail', race?.event_id, race?.market_id]"><span class="">{{race?.market_start_time_format | date : 'HH:mm'}}</span></a>
                    </div>
                </div>
            </div>
        </div>
    
        </tab>
      </tabset>

      <div *ngIf="datalength == 0" class="norecords"><a>No real-time records found</a></div>
    </div>
  </div>
